import React from 'react';
import {
  EventCard,
  CardFirstRow,
  CardSecondRow,
  CardThirdRow,
  CardFourthRow,
  LineSeparetor,
  CardFifthRow,
  ExecPhoto,
  ExecPhotoWrapper,
  MoreExecContainer,
  StatusIcon,
} from '../shared/styled';
import { ReactComponent as PendingAgIcon } from 'assets/icons/pending-ag-icon.svg';
import { ReactComponent as ExecutorNoPhotoIcon } from 'assets/icons/executor-no-photo-icon.svg';
import { CalendarEvent, EventColorSet } from 'pages/Agenda/utils';
import { useEventCardDisplay } from '../../../hooks/useEventCardDisplay';

interface AgendaEventCardProps {
  event: CalendarEvent;
  colorSet: EventColorSet;
  isCompletedView: boolean;
}

/**
 * Read-only event card for mobile list (no drag). Same layout as DraggableEvent.
 */
export const AgendaEventCard: React.FC<AgendaEventCardProps> = ({ event, colorSet, isCompletedView }) => {
  const { atividadesLabel, executorCount, firstExecutor, displayExecutors } = useEventCardDisplay(event);

  return (
    <EventCard borderLeft={colorSet.borderColor} backgroundColor={colorSet.backgroundColor} data-event-id={event.id}>
      <CardFirstRow fontColor={colorSet.fontColor}>
        <span>
          {event.time} • {event.title}
        </span>
        <StatusIcon color={event.realizada || isCompletedView ? '#4CAF50' : 'transparent'}>
          {event.realizada || isCompletedView ? '✓' : event.atrasada ? <PendingAgIcon width={12} height={12} /> : null}
        </StatusIcon>
      </CardFirstRow>
      <CardSecondRow>{event.aplicacao}</CardSecondRow>
      <CardThirdRow>{event.equipamento}</CardThirdRow>
      <CardFourthRow>
        {executorCount === 1 && firstExecutor ? (
          <>
            {firstExecutor.avatar ? (
              <ExecPhoto src={firstExecutor.avatar} alt={firstExecutor.nome} />
            ) : (
              <ExecPhotoWrapper>
                <ExecutorNoPhotoIcon width={20} height={20} />
              </ExecPhotoWrapper>
            )}
            <span
              style={{
                marginLeft: '6px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {firstExecutor.nome}
            </span>
          </>
        ) : (
          <MoreExecContainer>
            <div>
              {displayExecutors.map((exec, index) =>
                exec.avatar ? (
                  <ExecPhoto
                    key={`exec-${exec.nome}-${index}`}
                    src={exec.avatar}
                    alt={exec.nome}
                    style={{
                      marginLeft: index === 0 ? 0 : -8,
                      zIndex: index,
                      position: 'relative',
                    }}
                  />
                ) : (
                  <ExecPhotoWrapper
                    key={`exec-${exec.nome}-${index}`}
                    style={{
                      marginLeft: index === 0 ? 0 : -8,
                      zIndex: index,
                      position: 'relative',
                    }}
                  >
                    <ExecutorNoPhotoIcon width={20} height={20} />
                  </ExecPhotoWrapper>
                ),
              )}
              <span>{executorCount} executores</span>
            </div>
          </MoreExecContainer>
        )}
      </CardFourthRow>
      <LineSeparetor separetorColor={colorSet.separetorColor} />
      <CardFifthRow style={{ color: colorSet.fontColor }}>{atividadesLabel}</CardFifthRow>
    </EventCard>
  );
};
